import React from "react";

import AccountList from "../../components/accounts/AccountList";
import AccountTypeList from "../../components/accounts/AccountTypeList";
import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import { pageTitleClass } from "../../components/ui/styles";
import { useAppSelector } from "../../app/hooks";
import { getIsShowAccounts } from "../../features/accounts/accountsSlice";
import { route } from "../../static/route";
import { BreadcrumbType } from "../../types/common";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "રોજમેળ" },
];

const AccountsPage = () => {
  const isShowAccounts = useAppSelector(getIsShowAccounts);

  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>રોજમેળ</h1>
      </div>

      <div className="flex flex-col gap-6">
        {isShowAccounts ? <AccountList /> : <AccountTypeList />}
      </div>
    </AppLayout>
  );
};
export default AccountsPage;
